export default __webpack_public_path__ + "static/media/2_0002.ecd0eb7f.webp";